import styled, { css } from "styled-components";
import { Text } from "../Text";
import React from "react";

const ErrorContainerEl = styled.div<{ outlined?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;

  ${(p) =>
    p.outlined &&
    css`
      border: 1px solid ${p.theme.colors.borders.appBar};
      border-radius: 6px;
      background-color: ${p.theme.colors.background.light};
    `}
`;

type ErrorContentProps = {
  image: string;
  title: string;
  description?: string;
  outlined?: boolean;
};

export const ErrorContent = ({
  image,
  title,
  description,
  outlined,
}: ErrorContentProps) => {
  return (
    <ErrorContainerEl outlined={outlined}>
      <img src={image} alt="Error" />
      <Text fontSize="normal" fontWeight="demi" marginTopL marginBottomXs>
        {title}
      </Text>
      {description && (
        <Text fontSize="small" marginTopL marginBottomXs>
          {description}
        </Text>
      )}
    </ErrorContainerEl>
  );
};
